import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import BaseTaoSpreadsheetGuide from "@/pages/articles/basetao-spreadsheet-guide/page";
import BaseTaoSpreadsheetReview from "@/pages/articles/basetao-spreadsheet-review/page";
import BaseTaoShippingCost from "@/pages/articles/basetao-shipping-cost/page";
import IsBaseTaoLegit from "@/pages/articles/is-basetao-legit/page";
import BaseTaoCouponGuide from "@/pages/articles/basetao-coupon-guide/page";
import BaseTaoWarehouseGuide from "@/pages/articles/basetao-warehouse-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articles/basetao-spreadsheet-guide",
    element: <BaseTaoSpreadsheetGuide />,
  },
  {
    path: "/articles/basetao-spreadsheet-review",
    element: <BaseTaoSpreadsheetReview />,
  },
  {
    path: "/articles/basetao-shipping-cost",
    element: <BaseTaoShippingCost />,
  },
  {
    path: "/articles/is-basetao-legit",
    element: <IsBaseTaoLegit />,
  },
  {
    path: "/articles/basetao-coupon-guide",
    element: <BaseTaoCouponGuide />,
  },
  {
    path: "/articles/basetao-warehouse-guide",
    element: <BaseTaoWarehouseGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;